/**
 * Combined Stock drawer: inventory and prices share a surface, not an authority.
 * Stock uses inventory RPCs. Prices use save_variant_selling_prices.
 */
export function stockInputsDirty(qtyByVariant: Record<string, string>, simpleQty: string, isVariant: boolean): boolean {
  if (!isVariant) return simpleQty.trim() !== "";
  return Object.values(qtyByVariant).some((raw) => raw != null && raw.trim() !== "");
}

export function priceInputsDirty(
  current: Record<string, string>,
  seeded: Record<string, string>,
): boolean {
  const ids = new Set([...Object.keys(current), ...Object.keys(seeded)]);
  for (const id of ids) {
    if ((current[id] ?? "").trim() !== (seeded[id] ?? "").trim()) return true;
  }
  return false;
}

export function describeStockPriceSaveOutcome(input: {
  stockAttempted: boolean;
  priceAttempted: boolean;
  stockError: string | null;
  priceError: string | null;
}): { ok: boolean; message: string | null } {
  const { stockAttempted, priceAttempted, stockError, priceError } = input;
  if (!stockError && !priceError) return { ok: true, message: null };
  const parts: string[] = [];
  if (stockAttempted && stockError) parts.push(`Stock not saved: ${stockError}`);
  else if (stockAttempted && priceError) parts.push("Stock saved.");
  if (priceAttempted && priceError) parts.push(`Prices not saved: ${priceError}`);
  else if (priceAttempted && stockError) parts.push("Prices saved.");
  return { ok: false, message: parts.join(" ") };
}
